import request from '@/utils/request'

const PREFIX = '/signstore/party'

export function partySnapshot(params) {
  return request.get(PREFIX + '/snapshot', { params })
}

export function partyScreenBootstrap(params) {
  return request.get(PREFIX + '/screen/bootstrap', { params })
}

/** 入场（须头像昵称） */
export function partyJoin(data) {
  return request.post(PREFIX + '/join', data)
}

/** 上报增量分数 */
export function partyScoreReport(data) {
  return request.post(PREFIX + '/score/report', data)
}

/** 通用互动事件：message / vote / grab / like */
export function partyEvent(data) {
  return request.post(PREFIX + '/event', data)
}

/** 照片抽奖：入场后上传/更新个人照片 */
export function partyUploadPhoto(data) {
  return request.post(PREFIX + '/photo', data)
}

/** 入场头像上传到 OSS（返回 images/ 文件名，库表仅存文件名） */
export function partyUploadImage(formData) {
  return request.post('/upload/image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
